import React, { Dispatch, SetStateAction } from 'react';
import {
  View, Text, StyleSheet, Pressable, ScrollView,
} from 'react-native';
import { FontAwesome } from '@expo/vector-icons';
import UserIcon24 from './24pxIcons/UserIcon24';
import Colors from '../constants/Colors';
import Style from '../constants/Style';
import { UserGroup } from '../constants/Types';
import PressableStyled, { PressableState } from './PressableStyled';
import DeleteIcon12 from './12pxIcons/DeleteIcon12';

interface UserGroupSelectionProps {
  userGroups: UserGroup[],
  selectedGroups: UserGroup[],
  selectedGroup: UserGroup,
  setSelectedGroup: Dispatch<SetStateAction<UserGroup>>,
  removeGroup: () => void,
  style,
  index: number,
  dropdownSelectionIndex: number | null,
  setDropdownSelectionIndex: Dispatch<SetStateAction<number | null>>,
}

const UserGroupSelection = ({
  userGroups, selectedGroups, selectedGroup, setSelectedGroup, removeGroup, style, index,
  dropdownSelectionIndex, setDropdownSelectionIndex,
}: UserGroupSelectionProps) => {
  const selected: boolean = dropdownSelectionIndex === index;

  return <View style={[styles.container, style]}>
    <Pressable
      onPress={() => setDropdownSelectionIndex(selected ? null : index)}
      style={styles.tag}
    >
      <View style={Style.row}>
        <UserIcon24 />
        <Text style={styles.tagText}>{selectedGroup.Name}</Text>
      </View>
      <View style={Style.row}>
        <FontAwesome
          color={'#FFF'}
          size={20}
          name={selected ? 'angle-up' : 'angle-down'}
        />
        <PressableStyled
          onPress={removeGroup}
          style={styles.removeGroupButton}
        >
          <DeleteIcon12 />
        </PressableStyled>
      </View>
    </Pressable>
    <View>
      {selected && <ScrollView style={Style.dropdownMenu}>
        {userGroups
          .filter((userGroup: UserGroup) => !selectedGroups.includes(userGroup))
          .map((userGroup: UserGroup) => <View
            key={`user_group_option_${userGroup.UserGroupId}`}
            style={{}}
          >
            <Pressable
              style={({ hovered, pressed }: PressableState) => [
                Style.dropdownOption,
                hovered && Style.listItemHovered, pressed && Style.listItemPressed,
              ]}
              onPress={() => {
                setSelectedGroup(userGroup);
                setDropdownSelectionIndex(null);
              }}
            >
              <Text style={Style.dropdownText}>{userGroup.Name}</Text>
            </Pressable>
          </View>)}
      </ScrollView>}
    </View>
  </View>;
};

const styles = StyleSheet.create({
  container: {
    marginEnd: 8,
    minWidth: 167,
  },
  tag: {
    ...Style.row,
    backgroundColor: Colors.light.hereworksDarkBlue,
    borderRadius: 8,
    paddingVertical: 4,
    paddingHorizontal: 8,
    marginVertical: 2,
  },
  tagText: {
    color: '#FFF',
    fontFamily: 'Roboto_400Regular',
    fontSize: 16,
    lineHeight: 24,
    marginHorizontal: 4,
  },
  removeGroupButton: {
    marginStart: 4,
  },
});

export default UserGroupSelection;
